import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CLIENT_SHIPPING_MODES } from "@utils/ClientShipping";

/**
 * El proveedor solo se pide en la modalidad externa: en la propia el envio lo factura el
 * suscriptor con su propio producto y no hay tercero que declarar.
 */
const ClientShippingOptionFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "mode",
                        "label": "Modalidad",
                        "options": CLIENT_SHIPPING_MODES,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerId",
                        "label": "Proveedor de Envio",
                        "visibleIf": {
                            "mode": "external"
                        },
                        "validation": Yup.string().when("mode", {
                            is: (mode: unknown) => `${mode || ""}` === "external",
                            then: (s) => s.required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                            otherwise: (s) => s.notRequired(),
                        }),
                    },
                    {
                        // Sin validacion Yup: el input `money` entrega el valor ya
                        // formateado y `Yup.number()` lo rechazaria.
                        "type": "money",
                        "name": "amount",
                        "label": "Costo de Envio",
                    },
                ],
            ]
        }
    ],
};

export default ClientShippingOptionFormConfig;
